/* eslint-disable @next/next/no-img-element */
/**
 * ServiceValueBadges
 *
 * The two trust value-prop badges shown in the service details modal:
 * "Background-checked beauty pros" and "Licensed pros with 2+ yrs of
 * experience". Rendered under the client-count controls on mobile and under the
 * Add Service button on desktop, per the Figma "Cro Sprint" design.
 */
import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../../helpers'
import { gsColors } from '../../../../styles/Variables'
import { Text } from '../../../../styles/Components'

const Badges = styled.div`
  display: flex;
  gap: 24px;
  margin: 20px 0;

  .value-badge {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
  }

  .value-badge img {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
  }

  .value-badge p {
    text-align: left;
    font-size: 14px !important;
  }

  ${mq('max', '768px')} {
    gap: 15px;

    .value-badge {
      gap: 6px;
    }

    .value-badge img {
      width: 20px;
      height: 20px;
    }

    .value-badge p {
      font-size: 12px !important;
    }
  }
`

const ServiceValueBadges = () => (
  <Badges>
    <div className="value-badge">
      <img src="/images/value-prop-background-check.svg" alt="" aria-hidden="true" />
      <Text color={gsColors.darkGrey} lineHeight="16px">
        Background-checked beauty pros
      </Text>
    </div>
    <div className="value-badge">
      <img src="/images/value-prop-license.svg" alt="" aria-hidden="true" />
      <Text color={gsColors.darkGrey} lineHeight="16px">
        Licensed pros with 2+ yrs of experience
      </Text>
    </div>
  </Badges>
)

export default ServiceValueBadges
